import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { AuthConstants } from 'src/app/constants/auth/auth-constants';
import { BearerToken } from 'src/app/models/BearerToken';
import { LoginCredentials } from 'src/app/models/LoginCredentials';
import { environment } from 'src/environments/environment';
import { EncryptionService } from './encryption.service';
import { ImpersonationInfoModel } from 'src/app/models/impersonationInfo.Model';
import { Router } from '@angular/router';
import { UserNotFound } from 'src/app/models/LoginErrors/UserNotFound';
import { ErrorConstants } from 'src/app/constants/error/error-constants';
import { UserLocked } from 'src/app/models/LoginErrors/UserLocked';
import { UserInactive } from 'src/app/models/LoginErrors/UserInactive';
import { UserDesactivated } from 'src/app/models/LoginErrors/userDesactivated';
import { CookieService } from 'ngx-cookie-service';
const ROLE_PREVIOUS_ADMINISTRATOR = 'ROLE_PREVIOUS_ADMINISTRATOR';
import { CustomCookieService } from '../custom-cookie.service';
import { AffichageCGUService } from 'src/app/components/affichage-cgu/services/affichage-cgu.service';
import {UserBlockedNoActiveContract} from "../../models/LoginErrors/UserBlockedNoActiveContract";
import { EnvironmentService } from '../environment.service';
import { ConfigurationService } from '../configuration.service';


@Injectable({
  providedIn: 'root'
})
export class AuthentificationService {

  constructor(private http: HttpClient, private encryptionService: EncryptionService, private router: Router,
     private cookieService: CookieService, private customCookieService : CustomCookieService,
    private affichageCGUService: AffichageCGUService, private environmentService: EnvironmentService, private configurationService: ConfigurationService) { }

  headers = new HttpHeaders();
  authentificationSubject: Subject<any> = new Subject();
  authentificationObservable = this.authentificationSubject.asObservable();

  newRgbdDoc:boolean = false;
  oldRgbdDoc:boolean = false;
  typeDocumentRgpd='CGU_CONSENTEMENT';

  httpLogin(loginPayload): Observable<BearerToken> {
    const headers = new HttpHeaders({ 'Accept': 'application/json' });
    const params = new HttpParams().set('refresh', false);
    const options = { headers: headers, params: params };
    return this.http.post<BearerToken>(this.environmentService.get().serverUrl + AuthConstants.AUTH_ENDPOINT + AuthConstants.LOGIN_URL, { 'token': loginPayload }, options);
  }

  httpLogout(): Observable<any> {
    const headers = new HttpHeaders({ 'Accept': 'application/json' });
    return this.http.post<BearerToken>(this.environmentService.get().serverUrl + AuthConstants.AUTH_ENDPOINT + AuthConstants.LOGOUT_URL, null);
  }

  httpRefresh(loginPayload): Observable<BearerToken> {
    const headers = new HttpHeaders({ 'Accept': 'application/json' });
    const params = new HttpParams().set('refresh', true);
    const options = { headers: headers, params: params };
    return this.http.post<BearerToken>(this.environmentService.get().serverUrl + AuthConstants.AUTH_ENDPOINT + AuthConstants.LOGIN_URL, { 'token': loginPayload }, options);
  }


  clearAccessStorage() {
    this.customCookieService.deleteAllExcept(true, true);
  }

  overrideAccessStorage(data: BearerToken) {
    this.cookieService.delete('access');
    if (data.managerRedirectUrl) {
      this.cookieService.set('manager_redirect_url', data.managerRedirectUrl, null, null, null, true);
      data.managerRedirectUrl = null;
    }
    this.cookieService.set('access', JSON.stringify(data), null, null, null, true);
  }

  setAccessStorage(data: BearerToken) {
    if (!this.isEmpty(data.companyId) && !this.isEmpty(data.uuid)) {
      this.cookieService.set('access', JSON.stringify(data), null, null, null, true);
    } else {
      let newAccess = data;
      let oldAccess = this.getStoredAccess();
      if (oldAccess) {
        newAccess.companyId = oldAccess.companyId;
        newAccess.uuid = oldAccess.uuid;
      }
      this.cookieService.set('access', JSON.stringify(newAccess), null, null, null, true);
    }
  }

  getStoredAccess(): BearerToken {
    let access
    if(this.cookieService.check('access')){
      access = this.cookieService.get("access");
    }
    if (access != null && access != undefined && access.length > 0) {
      return JSON.parse(access);
    } else {
      return undefined;
    }
  }
  getStatusCgu(){
    const StatusCgu = this.cookieService.get("StatusCgu");
    if (StatusCgu != null && StatusCgu != undefined && StatusCgu.length > 0) {
      return StatusCgu;
    } else {
      return undefined;
    }
  }

  getTypeUser(){
    const typeUser = JSON.parse(this.cookieService.get("access")).type;
    if (typeUser != null && typeUser != undefined && typeUser.length > 0) {
      return typeUser;
    } else {
      return undefined;
    }
  }

  authenticate(credentials): Observable<any> {
    credentials.companyId = this.environmentService.get().companyIdentifier;
    credentials.companySiteId = this.environmentService.get().companySiteIdentifier;
    const encryptedCredentials = Object.assign({}, credentials);
    encryptedCredentials.password = this.encryptionService.encryptPassword(credentials.password);
    var jweSubscription = this.encryptionService.createJwtAuthentificationPayload(encryptedCredentials).subscribe(jwe => {
      this.unsubscribe(jweSubscription);
      var loginSubscription = this.httpLogin(jwe).subscribe({
        next: (data) => {
          if (data.forceUpdatePassword && data.forceUpdatePasswordUrl) {

            // FOR EASE OF TEST ONLY
            //let localurl = data.forceUpdatePasswordUrl.replace('https://assure-demo-tessi.owliance.net', 'http://localhost:4300');
            window.location.href = data.forceUpdatePasswordUrl;
          } else {
            this.unsubscribe(loginSubscription);
            if (!environment['MANAGER_TYPE']) {
              this.clearAccessStorage();
              this.setAccessStorage(data);
              //this.languageService.initLanguage('fr');
              this.authentificationSubject.next(data);
            } else {
              data.managerRedirectUrl = window.location.origin;
              window.location.href = data.managedRedirectUrl + "#/accueil?manager=" + encodeURIComponent(this.encryptionService.encryptPassword(JSON.stringify(data)));
            }
          }

        }, error: (error) => {
          if (error?.errorCode == ErrorConstants.ACCOUNT_WITH_NO_CONTRACT) {
            this.authentificationSubject.next(new UserBlockedNoActiveContract(true));
          }else if (error?.errorCode == ErrorConstants.ACCOUNT_LOCKED) {
            this.authentificationSubject.next(new UserLocked(true));
          } else if (error?.errorCode == ErrorConstants.ACCOUNT_INACTIF) {
            this.authentificationSubject.next(new UserInactive(true));
          } else if (error?.errorCode == ErrorConstants.ACCOUNT_DESACTIVATED) {
            this.authentificationSubject.next(new UserDesactivated(true));
          } else {
            this.authentificationSubject.next(new UserNotFound(true));
          }
          this.unsubscribe(loginSubscription);
        }
      });
    });
    return this.authentificationObservable;
  }


  getImpersonationInfo(): ImpersonationInfoModel {
    if (this.getStoredAccess().roles.filter(role => role == ROLE_PREVIOUS_ADMINISTRATOR).length > 0) {
      let impersonationInfo: ImpersonationInfoModel = new ImpersonationInfoModel();
      impersonationInfo.username = this.getStoredAccess().username;
      impersonationInfo.sourceUsername = this.getStoredAccess().sourceUsername;
      return impersonationInfo;
    }
    return null;
  }

  exitImpersonation() {
    this.http.post(this.environmentService.get().serverUrl + AuthConstants.EXIT_IMPERSONATION_ENDPOINT, null).subscribe(() => {
      this.clearAccessStorage();
      this.router.navigateByUrl("/auth/login");
    })
  }


  // promise mode
  refreshAuthentification() {
    return new Promise((resolve, reject) => {
      const storedAccess = this.getStoredAccess();
      if (storedAccess) {
        const credentials = new LoginCredentials();
        credentials.refresh = storedAccess.refresh_token;
        let jweSubscription = this.encryptionService.createJwtRefreshPayload(credentials).subscribe(jwe => {
          this.unsubscribe(jweSubscription);
          let refreshSubscription = this.httpRefresh(jwe).subscribe((data) => {
            this.clearAccessStorage();
            this.setAccessStorage(data);
            this.unsubscribe(refreshSubscription);
            //this.languageService.initLanguage('fr');
            resolve(data);
          }, () => {
            reject(new Error('Permission denied!'));
            return;
          });
        });
      } else {
        reject(new Error('Permission denied!'));
        return;
      }
    })
  }




  unsubscribe(subscription: Subscription) {
    subscription.unsubscribe();
  }


  private isEmpty(value) {
    return value == null || value == undefined;
  }

  isSignedIn() {
    const access = this.getStoredAccess();
    return !this.isEmpty(access) && !this.isEmpty(access.access_token);
  }

  isManagedAccess() {
    const managerUrl = this.cookieService.get('manager_redirect_url');
    return managerUrl != null && managerUrl != undefined && managerUrl.length > 0;
  }

  getManagedAccess() {
    return this.cookieService.get('manager_redirect_url');
  }

  clearManagedAccess() {
    this.cookieService.delete('manager_redirect_url');
  }

  public processSuccessfulAuthentication(data) {
    if (this.configurationService.get().maiia.enabled) {
        let access = this.getStoredAccess();
        if (access?.type !== 'ADMIN') {
            this.affichageCGUService.getStatusCgu(this.typeDocumentRgpd).subscribe((responseMessage) => {
                this.cookieService.set('StatusCgu',responseMessage.toString(), null, null, null, true);
              if (responseMessage == -1) {
                  this.newRgbdDoc = false;
                  this.oldRgbdDoc = true;
                  history.state.test = this.oldRgbdDoc
                  window.location.href = this.configurationService.get().maiia.SERVER_URL + this.configurationService.get().maiia.tokenPath + data.jwe + "&return_uri=" + window.location.origin + "/#/affichage-cgu";
              }
              else if (responseMessage == 1) {
                  this.oldRgbdDoc = false;
                  this.newRgbdDoc = true;
                  history.state.data = this.newRgbdDoc;
                  window.location.href = this.configurationService.get().maiia.SERVER_URL + this.configurationService.get().maiia.tokenPath + data.jwe + "&return_uri=" + window.location.origin + "/#/affichage-cgu";
              }
            else
            window.location.href = this.configurationService.get().maiia.SERVER_URL + this.configurationService.get().maiia.tokenPath + data.jwe + "&return_uri=" + window.location.origin + "/#/accueil";
          });
          } else {
              window.location.href = this.configurationService.get().maiia.SERVER_URL + this.configurationService.get().maiia.tokenPath + data.jwe + "&return_uri=" + window.location.origin + "/#/accueil";
          }
    } else {
        let access = this.getStoredAccess();
        if (access?.type !== 'ADMIN') {
          this.affichageCGUService.getStatusCgu(this.typeDocumentRgpd).subscribe((responseMessage) => {
            this.cookieService.set('StatusCgu',responseMessage.toString(), null, null, null, true);
            if (responseMessage == -1) {
                this.newRgbdDoc = false;
                this.oldRgbdDoc = true;
                this.router.navigate(['/affichage-cgu'], { state: { test: this.oldRgbdDoc } });
            }
            else if (responseMessage == 1) {
                this.oldRgbdDoc = false;
                this.newRgbdDoc = true;
                this.router.navigate(['/affichage-cgu'], { state: { data: this.newRgbdDoc } });
            }
            else
            { this.router.navigate(['/accueil']);}
        });
        } else {
          this.router.navigate(['/accueil']);
        }
    }
}

}
